import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { TOLL_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import TollForm from './TollForm';
import { getToll, putToll } from '../../../../actions';

const EditToll = ({
  breadcrumbs,
  dispatchGetToll,
  dispatchPutToll,
  match: {
    params: { id: tollId },
  },
  loading,
  toll,
}) => {
  useLayoutEffect(() => {
    dispatchGetToll({ tollId });
  }, [dispatchGetToll, tollId]);

  const onSubmit = (formValues) => {
    const pricePerAxle = Number(formValues.pricePerAxle);
    const taxPrePaymentPerAxle = Number(formValues.taxPrePaymentPerAxle);
    const electronic = Boolean(formValues.electronic);

    const newFormValues = {
      ...formValues,
      locationId: formValues.locationId && formValues.locationId.value,
      pricePerAxle,
      taxPrePaymentPerAxle,
      electronic,
      isExtraordinary: Boolean(formValues.isExtraordinary),
      provia: Boolean(formValues.provia),

      electronicPricePerAxle: electronic ? pricePerAxle : null,
      electronicTaxPrePaymentPerAxle: electronic ? taxPrePaymentPerAxle : null,
      businessId: formValues.business && formValues.business.value
    };

    dispatchPutToll(tollId, newFormValues);
  };
  const generateInitialValues = ({
    locationId,
    location,
    locationName,
    pricePerAxle,
    taxPrePaymentPerAxle,
    electronic,
    isExtraordinary,
    provia,
    businessId,
    business
  }) => ({
    locationId: location
      ? {
          value: location.id,
          label: location.name,
          city: location.address && location.address.city,
        }
      : {
          value: locationId,
          label: locationName || '',
        },
    pricePerAxle,
    taxPrePaymentPerAxle,
    electronic: Boolean(electronic),
    isExtraordinary: Boolean(isExtraordinary),
    provia: Boolean(provia),
    business: business ? {
      id: businessId,
      value: business.name,
      label: `${business.businessTaxId} - ${business.name}`
    } : null
  });

  let content;

  if (loading) {
    content = <Loader />;
  } else if (toll.isEmpty()) {
    content = <NoDataResource returnPage={TOLL_PATH} />;
  } else {
    content = (
      <TollForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(toll.toJS())}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar peaje"
      subtitle="Editar registro de peaje"
      content={content}
    />
  );
};

EditToll.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetToll: PropTypes.func.isRequired,
  dispatchPutToll: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  toll: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditToll.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchGetToll: getToll,
  dispatchPutToll: putToll,
};

const mapStateToProps = (
  { RouteUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Peajes',
      href: TOLL_PATH,
    },
    {
      text: 'Ver',
      href: `${TOLL_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  toll: RouteUnit.Toll.getIn(['current', 'content']),
  loading: !RouteUnit.Toll.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditToll);
